import { Component } from "@angular/core";
import { AlertController, ModalController } from "@ionic/angular";
import { TranslocoService } from "@ngneat/transloco";
import { ApiService } from "../../configuration/services/api.service";
import { LocationStateService } from "../../configuration/state/location-state.service";
import { LocationStateQuery } from "source/app/configuration/state/location-state.query";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";
import { DowntimeTemplateReference } from "source/app/configuration/state/location-state.store";

@Component({
	selector: "app-down-location",
	templateUrl: "./down-location.component.html",
	styleUrls: ["./down-location.component.scss"],
})
export class DownLocationComponent {
	constructor(
		private modalController: ModalController,
		private apiService: ApiService,
		private locationStateQuery: LocationStateQuery,
		private locationStateService: LocationStateService,
		private translocoService: TranslocoService,
		private alertController: AlertController,
		private rideOpsUi: RideOpsUiService,
	) {}

	description: string;
	selectedTemplate: DowntimeTemplateReference;
	templates$ = this.locationStateQuery.downtimeTemplates$;
	saving = false;

	isV2 = (): boolean => this.rideOpsUi.isV2Active();

	createsAssignment = (template: DowntimeTemplateReference | null): boolean =>
		template?.assignmentConfigurationPolicyType === "Create";

	clearTemplate = () => {
		this.selectedTemplate = null;
		this.description = null;
	};

	toggleTemplate = (template: DowntimeTemplateReference) => {
		if (template == this.selectedTemplate) {
			if (!this.isV2()) {
				this.clearTemplate();
			}
			return;
		}

		this.selectedTemplate = template;
		this.description = template.description;
	};

	startDowntime = async () => {
		if (
			this.isV2() &&
			this.selectedTemplate == null &&
			(this.description == null || this.description.trim() === "")
		) {
			const confirmed = await this.confirmEmptyDowntime();
			if (!confirmed) {
				return;
			}
		}

		this.saving = true;
		try {
			const downtimeResult = await this.apiService.startDowntime(
				this.description,
				this.selectedTemplate?.categories,
				this.selectedTemplate?.id,
			);

			await this.locationStateService.createDowntimeAndCloseLocation(
				downtimeResult.downtimeId,
				this.description,
				this.selectedTemplate,
			);
			await this.modalController.dismiss();
		} catch {
			const alert = await this.alertController.create({
				message: this.translocoService.translate("DOWN_LOCATION__ERROR_MESSAGE"),
				buttons: [this.translocoService.translate("DOWN_LOCATION__OK")],
				backdropDismiss: true,
				cssClass: this.isV2() ? "operators-v2-dialog" : undefined,
			});

			await alert.present();
		}
		this.saving = false;
	};

	dismiss = () => {
		this.modalController.dismiss();
	};

	private confirmEmptyDowntime = async (): Promise<boolean> => {
		const alert = await this.alertController.create({
			header: this.translocoService.translate("DOWNTIME_MODAL__EMPTY_CONFIRM_TITLE"),
			message: this.translocoService.translate("DOWNTIME_MODAL__EMPTY_CONFIRM_MESSAGE"),
			backdropDismiss: true,
			cssClass: "operators-v2-dialog",
			buttons: [
				{
					text: this.translocoService.translate("BASE__CANCEL"),
					role: "cancel",
				},
				{
					text: this.translocoService.translate("DOWNTIME_MODAL__START_DOWNTIME"),
					role: "ok",
				},
			],
		});

		await alert.present();
		const { role } = await alert.onDidDismiss();
		return role === "ok";
	};
}
